<template>
  <div>
    <div>
      <h4>
        {{ "pay_done" | setText("Оплата подтверждена") }}
      </h4>
      <div>
        <button @click="next" class="btn btn-info mw">
          {{ "next" | setText("Далее") }}
        </button>
      </div>

      <button
        v-if="$store.state.user.is_root"
        @click="cancel"
        class="btn btn-danger mw mt-5"
      >
        {{ "cancel_pay" | setText("Отменить оплату") }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    done() {
      return (
        this.transaction &&
        this.transaction.system_confirmed &&
        this.transaction.client_confirmed
      );
    },
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  mounted() {
    setInterval(() => {
      this.timer--;
    }, 1000);
  },
  name: "filter",
  methods: {
    next() {
      this.$emit("setStep", null);
    },
    cancel() {
      this.createTransaction({
        client_confirmed: 0,
        system_confirmed: 0,
        step: "processing",
      });
      this.$emit("setStep", "processing");
    },
  },
  data() {
    return {};
  },
};
</script>

